// extracted by mini-css-extract-plugin
export var inlineLink = "_9e-0";
export var inlineLinkButton = "_9e-1";